import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const ASSIGNED_CUSTOMER: AppRouteRecordRaw = {
  path: '/assigned-customer',
  name: 'assigned-customer',
  component: DEFAULT_LAYOUT,
  redirect: '/assigned-customer/list',
  meta: {
    locale: 'menu.assignedCustomer',
    requiresAuth: true,
    icon: 'icon-calendar',
    order: 1,
    hideChildrenInMenu: true,
    activeMenu: 'assigned-customer',
  },
  children: [
    {
      path: 'list',
      name: 'AssignedCustomer',
      component: () => import('@/views/assignedCustomer/index.vue'),
      meta: {
        locale: 'menu.assignedCustomer',
        requiresAuth: true,
        roles: ['*'],
      },
    },
  ],
};

export default ASSIGNED_CUSTOMER;
